import { GOOGLE_RECAPTCHA } from '../../config/Keys'

const useRecaptcha = (callback) => {
    return (values, actions) => {
        if (window.grecaptcha) {
            window.grecaptcha.ready(function () {
                window.grecaptcha
                    .execute(GOOGLE_RECAPTCHA, { action: 'submit' })
                    .then(function (token) {
                        callback(
                            {
                                ...values,
                                token,
                            },
                            actions
                        )
                    })
            })
        } else {
            callback(values, actions)
        }
    }
}

export default useRecaptcha
